<template>
  <canvas
    ref="confettiCanvas"
    :width="width"
    :height="height"
    class="confetti-canvas"
  ></canvas>
</template>

<script>
export default {
  name: "Confetti",

  data() {
    return {
      width: window.innerWidth,
      height: window.innerHeight,
      confettiPieces: [],
    };
  },

  mounted() {
    this.triggerConfetti();
  },

  methods: {
    triggerConfetti() {
      const canvas = this.$refs.confettiCanvas;
      const ctx = canvas.getContext("2d");

      // Criar confetes
      this.confettiPieces = Array.from({ length: 100 }, () =>
        this.createConfetti()
      );

      const updateConfetti = () => {
        ctx.clearRect(0, 0, this.width, this.height);

        // Atualizar e renderizar confetes
        this.confettiPieces.forEach((piece) => {
          piece.x += piece.vx;
          piece.y += piece.vy;
          piece.rotation += piece.vr;

          // Desenhar confete
          ctx.save();
          ctx.translate(piece.x, piece.y);
          ctx.rotate(piece.rotation);
          ctx.fillStyle = piece.color;
          ctx.fillRect(
            -piece.size / 2,
            -piece.size / 2,
            piece.size,
            piece.size
          );
          ctx.restore();

          // Reutilizar confetes fora da tela
          if (piece.y > this.height || piece.x < 0 || piece.x > this.width) {
            Object.assign(piece, this.createConfetti());
            piece.y = -piece.size;
          }
        });

        requestAnimationFrame(updateConfetti);
      };

      updateConfetti();
    },

    createConfetti() {
      const colors = [
        "#f44336",
        "#e91e63",
        "#9c27b0",
        "#3f51b5",
        "#03a9f4",
        "#4caf50",
        "#ffeb3b",
        "#ff9800",
      ];

      return {
        x: Math.random() * this.width,
        y: Math.random() * this.height - this.height / 2,
        vx: Math.random() * 4 - 2,
        vy: Math.random() * 4 + 2,
        size: Math.random() * 8 + 4,
        rotation: Math.random() * 2 * Math.PI,
        vr: Math.random() * 0.1 - 0.05,
        color: colors[Math.floor(Math.random() * colors.length)],
      };
    },
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
